export type LocaleCode =
   | 'en-us'
   | 'en-ca'
   | 'en-au'
   | 'en-gb'
   | 'fr-ca'
   | 'fr-fr'
   | 'de-de'
   | 'it-it'
   | 'es-es'
   | 'en-eu';
export type LanguageCode = 'en' | 'fr' | 'de' | 'it' | 'es';

export type ProductIndex =
   | 'product_en_us'
   | 'product_en_ca'
   | 'product_en_uk'
   | 'product_en_au'
   | 'product_en_eu'
   | 'product_fr_ca'
   | 'product_fr_fr'
   | 'product_de_de'
   | 'product_it_eu'
   | 'product_es_eu';

export const PRODUCT_INDICES_BY_LOCALE: Record<LocaleCode, ProductIndex> = {
   'en-us': 'product_en_us',
   'en-gb': 'product_en_uk',
   'en-au': 'product_en_au',
   'en-ca': 'product_en_ca',
   'en-eu': 'product_en_eu',
   'fr-ca': 'product_fr_ca',
   'fr-fr': 'product_fr_fr',
   'de-de': 'product_de_de',
   'it-it': 'product_it_eu',
   'es-es': 'product_es_eu',
};

/**
 * The store_offer index family (issue #55186): the A/B-test treatment to the
 * product control. One card per "store offer" (a curated split-axis combo)
 * instead of one per product group. Mirrors PRODUCT_INDICES_BY_LOCALE; the PLP
 * query resolver swaps to these when the plp-store-offer-index flag is on.
 */
export type StoreOfferIndex =
   | 'store_offer_en_us'
   | 'store_offer_en_ca'
   | 'store_offer_en_uk'
   | 'store_offer_en_au'
   | 'store_offer_en_eu'
   | 'store_offer_fr_ca'
   | 'store_offer_fr_fr'
   | 'store_offer_de_de'
   | 'store_offer_it_eu'
   | 'store_offer_es_eu';

export const STORE_OFFER_INDICES_BY_LOCALE: Record<LocaleCode, StoreOfferIndex> = {
   'en-us': 'store_offer_en_us',
   'en-gb': 'store_offer_en_uk',
   'en-au': 'store_offer_en_au',
   'en-ca': 'store_offer_en_ca',
   'en-eu': 'store_offer_en_eu',
   'fr-ca': 'store_offer_fr_ca',
   'fr-fr': 'store_offer_fr_fr',
   'de-de': 'store_offer_de_de',
   'it-it': 'store_offer_it_eu',
   'es-es': 'store_offer_es_eu',
};

export const LOCALIZED_FACET_MAPPINGS_BY_INDEX = {
   product_en_us: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_ca: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_uk: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_au: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_en_eu: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacity',
      'facet_tags.Item Type': 'facet_tags_localized.Item Type',
      'facet_tags.Part or Kit': 'facet_tags_localized.Part or Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Tool Category',
      'facet_tags.Main Category': 'facet_tags_localized.Main Category',
      'worksin': 'worksin',
   },
   product_fr_ca: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacité',
      'facet_tags.Item Type': 'facet_tags_localized.type de produit',
      'facet_tags.Part or Kit': 'facet_tags_localized.Pièce ou kit',
      'facet_tags.Tool Category': "facet_tags_localized.Catégorie d'outils",
      'facet_tags.Main Category': 'facet_tags_localized.catégorie principale',
      'worksin': 'worksin',
   },
   product_fr_fr: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacité',
      'facet_tags.Item Type': 'facet_tags_localized.type de produit',
      'facet_tags.Part or Kit': 'facet_tags_localized.Pièce ou kit',
      'facet_tags.Tool Category': "facet_tags_localized.Catégorie d'outils",
      'facet_tags.Main Category': 'facet_tags_localized.catégorie principale',
      'worksin': 'worksin',
   },
   product_de_de: {
      'facet_tags.Capacity': 'facet_tags_localized.Kapazität',
      'facet_tags.Item Type': 'facet_tags_localized.Produkttyp',
      'facet_tags.Part or Kit': 'facet_tags_localized.Ersatzteil oder Kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Werkzeugtyp',
      'facet_tags.Main Category': 'facet_tags_localized.Hauptkategorie',
      'worksin': 'worksin',
   },
   product_it_eu: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacità',
      'facet_tags.Item Type': 'facet_tags_localized.Tipo di prodotto',
      'facet_tags.Part or Kit': 'facet_tags_localized.Parte o kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Categoria strumenti',
      'facet_tags.Main Category': 'facet_tags_localized.Categoria principale',
      'worksin': 'worksin',
   },
   product_es_eu: {
      'facet_tags.Capacity': 'facet_tags_localized.Capacidad',
      'facet_tags.Item Type': 'facet_tags_localized.Tipo de producto',
      'facet_tags.Part or Kit': 'facet_tags_localized.Pieza o kit',
      'facet_tags.Tool Category': 'facet_tags_localized.Categoría de herramientas',
      'facet_tags.Main Category': 'facet_tags_localized.Categoría principal',
      'worksin': 'worksin',
   },
} as const;

export type LocalizedFacetMappings = typeof LOCALIZED_FACET_MAPPINGS_BY_INDEX;
export type FacetKey = keyof LocalizedFacetMappings[ProductIndex];

/**
 * Resolve any resolved query index name back to its control product index.
 *
 * The store_offer A/B treatment (issue #55186) swaps the product index for a
 * parallel `store_offer_*` index, but store_offer records carry the identical
 * `facet_tags_localized.*` attributes (AlgoliaStoreOfferHandler extends
 * AlgoliaProductHandler). Anything keyed by the *control* index name — like
 * LOCALIZED_FACET_MAPPINGS_BY_INDEX — should look up against the product
 * sibling regardless of which index the flag routed the query to. Passes
 * product_* names through unchanged.
 */
export function controlProductIndex(indexName: string): ProductIndex {
   return indexName.replace(/^store_offer_/, 'product_') as ProductIndex;
}

export function localizedFacetFor({ key, locale }: { key: FacetKey; locale: LocaleCode }) {
   const productIndex = PRODUCT_INDICES_BY_LOCALE[locale];
   return LOCALIZED_FACET_MAPPINGS_BY_INDEX[productIndex][key];
}

/**
 * The localized-facet attribute map for a resolved query index. Accepts both
 * product_* and the store_offer_* A/B treatment names (issue #55186); the
 * latter resolve to their product sibling since the facet attributes match.
 */
export function getLocalizedFacetMappings(indexName: string) {
   return LOCALIZED_FACET_MAPPINGS_BY_INDEX[controlProductIndex(indexName)];
}

export function getIsProAlgoliaFilter({
   includeProProducts,
}: {
   includeProProducts: boolean;
}): string {
   const nonProUserFilter = 'is_pro <= 0';
   const proUserFilter = 'is_pro >= 0';
   return includeProProducts ? proUserFilter : nonProUserFilter;
}
